// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: every user-visible string of the favorites preview and bookmark notes, word for word
// favorites-bookmarks-plan.md section 5 (favorites_bookmarks_strings_table.md is the repo copy, checked by
// FavoritesBookmarksStrings.test.ts). The new ones are English only, like the calendar's; the ones upstream already
// has stay its lingui descriptors, so they read and translate as the DM row and the dialogs do. Exclude from
// upstream sync.

import {CANCEL_DESCRIPTOR, SAVE_DESCRIPTOR} from '@app/features/i18n/utils/CommonMessageDescriptors';
import {msg} from '@lingui/core/macro';

export const FavoritesBookmarksStrings = {
	someone: 'Someone',
	addNote: 'Add note',
	editNote: 'Edit note',
	note: 'Note',
	noteNotSaved: "The note wasn't saved. Try again.",
} as const;

// The DM row's own descriptors (DMListItem.tsx), the same message, so the same catalog entry.
export const PREVIEW_YOU_DESCRIPTOR = msg({
	message: 'You',
	comment: 'First-person prefix used in DM list row preview when the current user is the message author.',
});
export const PREVIEW_SENT_AN_ATTACHMENT_DESCRIPTOR = msg({
	message: 'Sent an attachment',
	comment: 'DM list row preview text when the most recent message has only attachments.',
});
export const NOTE_SAVE_DESCRIPTOR = SAVE_DESCRIPTOR;
export const NOTE_CANCEL_DESCRIPTOR = CANCEL_DESCRIPTOR;

/** The preview's author prefix and its text, as the DM row joins them. */
export const PREVIEW_SEPARATOR = ': ';
